import React, { useState } from 'react';
import { Image, Text } from 'react-native';
import { View } from 'react-native-web';
import { DraggableGrid } from 'react-native-draggable-grid';
import LinkTextButton from '../Buttons/LinkTextButton';
import { drag_methods_reorder, edit_order } from '../../../utils/DictionaryManagementUtils';
import EditOrderPanelButton from '../Buttons/EditOrderPanelButton';
import { img_arrange } from '../../../utils/ImagesManagementUtils';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import SwitcherPanel from '../Buttons/SwitcherPanel';

const ManuelRecipientMenu = ({
  globJSON,
  subCategoryId,
  onManualMethodValueChanged,
  language,
  onConfigChanged,
}) => {
  const myStyles = {
    methodText: {
      padding: 10,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 18,
      color: '#001a2f',
    },
    flexComponent: {
      width: '100%',
      marginBottom: 30,
      paddingVertical: 10,
      flexDirection: 'column',
      justifyContent: 'space-between',
      backgroundColor: '#f7fafc',
    },
    SwitcherPanelStyle: {
      width: 460, padding: 5,
    },
    img_arrangeStyle: {
      height: 20,
      width: 20,
      marginLeft: -13,
      position: 'absolute',
    },
  };
  const { recipient } = globJSON.configurations.services[subCategoryId];
  const [displayScreens, setDisplayScreens] = useState(recipient.screens_ordering.map((manualKey) => ({ key: manualKey })));
  const [draggingState, setDraggingState] = useState({
    nowDragging: false,
    defaultOrder: [],
  });
  const onStartEditOrderPressed = () => {
    setDraggingState({
      nowDragging: true,
      defaultOrder: [...displayScreens],
    });
  };
  const onSaveEditOrderPressed = () => {
    recipient.screens_ordering = displayScreens.map((screen) => screen.key);
    arrangeScreenInJson(globJSON, onConfigChanged);
    setDraggingState({ nowDragging: false, defaultOrder: [] });
  };
  const onCancelEditOrderPressed = () => {
    setDisplayScreens(draggingState.defaultOrder);
    setDraggingState({ nowDragging: false, defaultOrder: [] });
  };
  const onDragReleased = (newArray) => {
    setDisplayScreens(newArray);
  };
  const render_item = (item) => (
    <View style={myStyles.SwitcherPanelStyle} key={item.key}>
      {draggingState.nowDragging && (
        <Image
          style={myStyles.img_arrangeStyle}
          source={img_arrange}
        />
      )}
      <SwitcherPanel
        text={recipient.manual_recipients[item.key].manual_name}
        value={recipient.manual_recipients[item.key].selected}
        onValueChanged={(value) => {
          onManualMethodValueChanged(item.key, value);
        }}
      />
    </View>
  );

  return (
    <View>
      <View style={myStyles.flexComponent}>
        {!draggingState.nowDragging && (
        <LinkTextButton onPress={onStartEditOrderPressed}>{edit_order}</LinkTextButton>)}
        {draggingState.nowDragging && <Text style={myStyles.methodText}>{drag_methods_reorder}</Text>}
        <View style={{ width: '100%', height: 47 * displayScreens.length }}>
          <DraggableGrid
            numColumns={1}
            renderItem={render_item}
            itemHeight={47}
            data={displayScreens}
            onDragRelease={(data) => {
              onDragReleased(data);
            }}
          />
        </View>
        {draggingState.nowDragging
                && (
                <EditOrderPanelButton
                  onPressSave={onSaveEditOrderPressed}
                  onPressCancel={onCancelEditOrderPressed}
                  language={language}
                />
                )}
      </View>
    </View>
  );
};
export default ManuelRecipientMenu;
